<template>
  <form class="redefinir-form" @submit.prevent="handleSubmit">
    <h1>Recuperar Acesso</h1>

    <Input
      type="email"
      legend="Email do usuário"
      placeholder="Digite seu email"
      :modelValue="email"
      @update:modelValue="$event => (email = $event)"
      variant="dark"
      :disabled="loading"
      data-testid="email-input"
    />

    <Button
      type="submit"
      :text="loading ? 'ENVIANDO...' : 'ENVIAR'"
      color="primary"
      :disabled="loading"
      data-testid="enviar-button"
    />

    <router-link class="return-link" :to="{ name: 'login', params: { autoescola: this.$route.params.autoescola || '' } }" data-testid="voltar-link">
      <ArrowLeftThin :size="22" />
      Voltar
    </router-link>
  </form>
</template>

<script>
import Button from 'core/Button'
import Input from 'core/Input'

import ArrowLeftThin from 'icons/ArrowLeftThin'
import Vue from 'vue'

export default {
  name: 'redefinir-senha',
  components: {
    Input,
    Button,

    ArrowLeftThin,
  },
  data() {
    return {
      email: '',
      loading: false,
    }
  },
  methods: {
    async handleSubmit() {
      if (this.validateInputs()) {
        await this.redefinirSenha()
      }
    },
    validateInputs() {
      if (!this.email) {
        this.$toasted.show('Preencha o campo de email!', {
          icon: 'fa-times',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })

        return false
      }

      return true
    },
    async redefinirSenha() {
      this.loading = true

      await this.$http
        .post(`${process.env.VUE_APP_URL_API}/login/reset-password`, {
          email: this.email,
        })
        .then(({ body }) => {
          this.$toasted.show(body.mensagem, {
            icon: 'fa-check',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })

          this.$router.push({ name: 'login' })
        })
        .catch(res => {
          if (res.status === 422) {
            Object.keys(res.body.errors).forEach(function (key) {
              Vue.toasted.show(res.body.errors[key][0], {
                icon: 'fa-times',
                position: 'top-right',
                duration: 5000,
                fullWidth: false,
              })
            })
          } else {
            this.$toasted.show('Erro não identificado!', {
              icon: 'fa-times',
              position: 'top-right',
              duration: 5000,
              fullWidth: false,
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.redefinir-form {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  h1 {
    margin: 0;
    font-weight: 700;
    font-size: 3rem;
    line-height: 100%;
    letter-spacing: -0.11px;
    color: #202224;
  }

  > Button {
    height: auto;
    padding: 1.25rem;
    justify-content: center;
    font-size: 1rem;
    font-family: Inter;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 0%;
  }

  .return-link {
    all: unset;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    font-weight: 400;
    font-size: 1rem;
    line-height: 100%;
    letter-spacing: 0%;
    color: #1b2c5a;
    cursor: pointer;
  }
}
</style>
